/* Panambi 360 · Test A/B — medición en la tienda.
 *
 * La asignación A/B la hace p360-ab-head.liquid en el <head> (sin parpadeo). Este archivo solo mide:
 *  1. Exposición: avisa de qué versión ha visto la clienta en esta ficha.
 *  2. Añadir a la cesta desde la ficha, con la versión vista.
 *  3. Guarda la versión en un atributo oculto del carrito (_p360_ab), que llega al pedido de Shopify:
 *     así las compras de cada versión se cuentan con pedidos reales, no con estimaciones.
 * Los eventos se publican como eventos de cliente de Shopify (los recoge el píxel personalizado
 * "Panambi 360 A/B" y los manda a GA4) y también a dataLayer si hay Google Tag Manager.
 * Las visitas de previsualización (?p360_ab=…) no se miden.
 */
// Versión B con otra foto principal: el carrusel de Ella (slick) arranca en esa foto. También en la vista previa.
(function () {
  const n = window.P360AB && window.P360AB.gallery;
  if (!n) return;
  let tries = 0;
  const go = () => {
    const $ = window.jQuery, el = $ && $('.productView-nav[data-image-gallery-main]');
    if (el && el.length && el.hasClass('slick-initialized')) { el.slick('slickGoTo', n - 1, true); return true; }
    return false;
  };
  if (!go()) { const iv = setInterval(() => { if (go() || ++tries > 60) clearInterval(iv); }, 100); }
})();

(function () {
  const AB = window.P360AB;
  if (!AB || AB.preview) return;
  const ids = Object.keys(AB.active).filter((id) => AB.running.includes(id));
  if (!ids.length) return;

  const tag = ids.map((id) => `${id}:${AB.active[id]}`).join(',');
  const send = (name, extra) => ids.forEach((id) => {
    const payload = Object.assign({ test_id: id, variant: AB.active[id], product: AB.product }, extra || {});
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish(name, payload); } catch (_) {}
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload));
  });

  send('p360_ab_exposure');

  document.addEventListener('panambi:added', (e) => {
    if (document.querySelector('[data-pdp]')) send('p360_ab_add_to_cart', { variant_id: e.detail && e.detail.id });
  });

  // Atributo del carrito: une todas las versiones vistas en la sesión (p. ej. "fit-modelo:b,envio-arriba:a").
  let seen = {};
  try { seen = JSON.parse(sessionStorage.getItem('p360_ab_seen') || '{}'); } catch (_) {}
  ids.forEach((id) => { seen[id] = AB.active[id]; });
  const attr = Object.keys(seen).map((id) => `${id}:${seen[id]}`).join(',');
  let last = null;
  try { last = sessionStorage.getItem('p360_ab_attr'); sessionStorage.setItem('p360_ab_seen', JSON.stringify(seen)); } catch (_) {}
  if (attr !== last) {
    fetch(((window.Panambi && Panambi.routes.cart) || '/cart') + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _p360_ab: attr } }) })
      .then(() => { try { sessionStorage.setItem('p360_ab_attr', attr); } catch (_) {} })
      .catch(() => {});
  }
  window.P360AB.tag = tag;
})();
